module.exports = __webpack_public_path__ + "img/button_last page.a1293237.png";